import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [],
  providers: [],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loggingIn: boolean = false;
  providerLoginInProgress = false;
  errorMessage = '';
  showContactLink = false;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    const authError = localStorage.getItem('authError');

    if (authError === 'login_not_completed') {
      this.errorMessage = 'Kunne ikke logge deg inn. Prøv igjen. Hvis du etter gjentatte ganger ikke kommer inn,';
      this.showContactLink = true;
    }

    if (authError === 'session_expired') {
      this.errorMessage = 'Sesjonen har utløpt. Du har blitt logget ut.';
      this.showContactLink = false;
    }
  }

  loginBankId() {
    if (this.providerLoginInProgress) return;
    this.providerLoginInProgress = true;
    localStorage.removeItem('authError');
    try {
      this.authService.loginWithBankId();
    } finally {
      this.providerLoginInProgress = false;
    }
  }


  login() {
    this.loggingIn = true;
  }
}
